module.exports = __webpack_public_path__ + "static/build-pipeline-0d37c3edcc952f86bd60d991a854ac70.png";